// src/components/AppPortal.js

import React from 'react';
import { useSelector } from 'react-redux';
import { selectTokens, selectAppRoles } from '../redux/userSlice';
import AppItem from './AppItem';
import './AppPortal.css'; // <--- Unique CSS file

const AppPortal = () => {
  const tokens = useSelector(selectTokens);
  const appRoles = useSelector(selectAppRoles) || {};

  const applications = {
    TMS: {
      name: 'TaxSale Management System',
      url: process.env.REACT_APP_TSM_URL,
    },
    LAP: {
      name: 'Lien Assist Program',
      url: process.env.REACT_APP_LIEN_URL,
    },
    NOTICING: {
      name: 'Noticing',
      url: process.env.REACT_APP_NS_URL,
    },
    FUT: {
      name: 'FUT',
      url: process.env.REACT_APP_FUT_URL,
    },
    TreasurerDeeds: {
      name: 'Treasurer Deeds',
      url: process.env.REACT_APP_FUT_URL + '/PuebloKIP/',
    },
    // Add other applications as necessary
    TD: {
      name: "Treasurer's Deed",
      url: process.env.REACT_APP_TD_URL,
    },
    SHERIFF: {
      name: "Sheriff (Foreclosure) Sale",
      url: process.env.REACT_APP_SHR_URL,
      // Sheriff-Sale-App handles SSO via FusionAuth's session cookie through its
      // own OAuth code flow, so we hand off to /login?sso=1 instead of passing
      // raw FusionAuth tokens in the URL.
      ssoViaFusionAuth: true,
    },
    ZEUS: {
      name: "Zeus Online Auction",
      url: process.env.REACT_APP_ZAS_URL,
    },
  };

  const handleAppSelection = (app) => {
    const accessToken = tokens.accessToken;
    const refreshToken = tokens.refreshToken;
    const target = app.ssoViaFusionAuth
      ? `${app.url}/login?sso=1`
      : `${app.url}?accessToken=${accessToken}&refreshToken=${refreshToken}`;

    window.open(target, '_blank'); // Opens the URL in a new tab
  };

  const userSystems = Object.keys(applications)
    .filter((key) => appRoles.hasOwnProperty(key))
    .map((key) => applications[key]);

  return (
    <section className="my-app-portal-container" aria-labelledby="app-portal-heading">
      <h2 id="app-portal-heading" className="my-app-portal-header">
        Application Portal
      </h2>
      <div className="my-app-portal-content">
        {userSystems.length > 0 ? (
          userSystems.map((app, index) => (
            <AppItem
              key={index}
              name={app.name}
              url={app.url}
              onAppSelect={() => handleAppSelection(app)}
            />
          ))
        ) : (
          <div className="my-app-portal-no-apps">
            No apps available.
          </div>
        )}
      </div>
    </section>
  );
};

export default AppPortal;
